import type { ReactNode } from 'react'
import { cn } from './cn'

export function Card({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('rounded-card bg-tg-section-bg shadow-sm ring-1 ring-black/5', className)}>
      {children}
    </div>
  )
}

export function CardRow({
  children,
  className,
  onClick,
}: {
  children: ReactNode
  className?: string
  onClick?: () => void
}) {
  const interactive = !!onClick
  return (
    <div
      className={cn('px-4 py-3', interactive && 'cursor-pointer active:bg-black/5', className)}
      onClick={onClick}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={
        interactive
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') onClick?.()
            }
          : undefined
      }
    >
      {children}
    </div>
  )
}
